import { KASPI_IMAGE_CDN_URL, KASPI_SHOP_URL } from "@src/config";

const KZT_FORMATTER = new Intl.NumberFormat("ru-RU");

export function formatPrice(value?: number | null) {
    if (value === null || value === undefined) {
        return "—";
    }
    return `${KZT_FORMATTER.format(value)} ₸`;
}

export function buildKaspiProductLink(path?: string | null) {
    if (!path) return undefined;
    const normalized = path.startsWith("/") ? path : `/${path}`;
    return `${KASPI_SHOP_URL}${normalized}`;
}

export function buildProductImageUrl(relativePath?: string | null) {
    if (!relativePath) return undefined;
    const trimmed = relativePath.trim();
    if (!trimmed) return undefined;
    const normalized = trimmed.startsWith("/") ? trimmed.slice(1) : trimmed;
    return `${KASPI_IMAGE_CDN_URL}${normalized}?format=preview-large`;
}
